


import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom'

const ApplicationFromPrivateRoute = ({ children }) => {
      const { isLoggedIn, userData, loginModale } = useSelector(
    (state) => state.auth,
  );

  const {course} = useParams()


    if(!isLoggedIn){
        return <Navigate to="/" replace/>
    }

    const isFirstYearStudent = userData?.admissions?.length === 0;

    if(isLoggedIn && isFirstYearStudent){
      return <Navigate to={`/admission-form/${course}/part-1`} replace/>
    }

    const isSecondYearStudent = userData?.admissions?.length === 1;




    if(isSecondYearStudent){

   
     let course =  userData?.admissions[0]?.course === "1" ? "ba" : ( userData?.admissions[0]?.course === "2" ? "bsc" : "bcom")
    }

      if(isLoggedIn && isSecondYearStudent){
      return <Navigate to={`/admission-form/${course}/part-2`} replace/>
    }
   
}

export default ApplicationFromPrivateRoute